import { useEffect, useMemo, useState } from "react";
import { Accordion } from "veronica-ui-component/dist/component/core";
import { CalendarAdjAccordion } from "./CalendarAdjAccordion";
import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { CountingAccordion } from "./CountingAccordion";
import { GracePeriodAccordion } from "./GracePeriodAccordion";
import { TierFSPAccordion } from "./TierFSPAccordion";

export const AccordionPanel = () => {
    const companyFSPVM = useCompanyFspVM();
    const [companyDetailState] = useCompanyDetailTracked();
    const { calendarAdjEnable, calendarAdjVisiable, countingEnabled, countingVisiable,
        gracePeriodEnabled, gracePeriodVisiable, tierFSPEnabled, tierFSPVisiable
    } = companyDetailState.companyFspState;
    const [currentAccordionData, setCurrentAccordionData] = useState<any[]>();


    const handleAccordionChange = (e: boolean, i: number) => {
        if (currentAccordionData) {
            const key = currentAccordionData.at(i)?.key;
            companyFSPVM.onAccordionPanelChange(e, key);
        }
    };

    const accordionData = useMemo(() => {
        const accordionData = []

        if (tierFSPEnabled) {
            accordionData.push({
                id: '1st Tier and 2nd Tier FSP(and UOM)',
                header: '1st Tier and 2nd Tier FSP(and UOM)',
                content: <TierFSPAccordion />,
                enableToggle: tierFSPVisiable ?? false,
                key: "tierFSPVisiable",
            })
        }
        if (countingEnabled) {
            accordionData.push({
                id: 'Counting From/To',
                header: 'Counting From/To',
                content: <CountingAccordion />,
                enableToggle: countingVisiable ?? false,
                key: "countingVisiable"
            })
        }
        if (calendarAdjEnable) {
            accordionData.push({
                id: 'Calendar Adjustment',
                header: 'Calendar Adjustment',
                content: <CalendarAdjAccordion />,
                enableToggle: calendarAdjVisiable ?? false,
                key: "calendarAdjVisiable"
            })
        }
        if (gracePeriodEnabled) {
            accordionData.push({
                id: 'Grace Period',
                header: 'Grace Period',
                content: <GracePeriodAccordion />,
                enableToggle: gracePeriodVisiable ?? false,
                key: "gracePeriodVisiable",
            })
        }

        return accordionData
    }, [calendarAdjEnable, calendarAdjVisiable, countingEnabled, countingVisiable, gracePeriodEnabled, gracePeriodVisiable, tierFSPEnabled, tierFSPVisiable]);

    useEffect(() => {
        setCurrentAccordionData(accordionData);
    }, [accordionData])

    return (
        <div className='flex-row-item flex-row-item-full-width'>
            <Accordion accordionData={accordionData} width="40vw" toggle onChange={(e, activeIndex) => { handleAccordionChange(e, activeIndex) }} />
            {companyDetailState.forceRefresh && <></>}
        </div>
    )
}